import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { AuthService, StoreService } from '@appCore/services';
import { BaseComponent } from '@appShared/components/base/base.component';
import { environment } from '@appEnvironments/environment';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent extends BaseComponent {
    public isHandset$: Observable<boolean>;
    public noticesCount: number = 0;

    constructor(
        breakpointObserver: BreakpointObserver,
        private router: Router,
        private storeService: StoreService,
        private authService: AuthService
    ) {
        super();
        this.isHandset$ = breakpointObserver.observe(Breakpoints.Handset).pipe(
            map((result) => result.matches),
            shareReplay()
        );
        this.getUnreviewedNoticeCount();
    }

    public setNavItemActive(routerLink: string) {
        return this.router.url.includes(routerLink);
    }

    public onLogoClick() {
        window.location.href = environment.launcherUrl;
    }

    public onLogout() {
        this.authService.logout();
    }

    private getUnreviewedNoticeCount() {
        const subs = this.storeService.selectNoticesCount().subscribe((state) => {
            this.noticesCount = state;
        });
        this.subscriptionList.push(subs);
    }
}
